export default __webpack_public_path__ + "5187638109660a6ead1757de25370214.ttf";